import DateFnsAdapter from '@mui/lab/AdapterDateFns';
import { addYears, endOfYear, isAfter, startOfYear } from "date-fns";

/**
 * Date adapter class that extends DateFnsAdapter, enabling the overriding of specific date adapter functions.
 */
export default class DateFnsAdapterWrapper extends DateFnsAdapter {

	/**
	 * Initialises a new instance of the DateFnsAdapterWrapper class.
	 */
	constructor() {
		super();

		// overrides the getYearRange function, which is used to output years when selecting a year on the date picker
		// outputs years in descending order
		this.getYearRange = (start: Date, end: Date) => {

			const startDate = startOfYear(start);
			const endDate = endOfYear(end);
			const years: Date[] = [];

			let current = endDate;
			while (isAfter(current, startDate)) {
				years.push(current);
				current = addYears(current, -1);
			}

			return years;
		};
	}
}